export default "__VITE_ASSET__XfY_2ORg__"